import { UserHelper } from '@/helpers/user.helper';
import { AlertService } from '@/services/alert.service';
import { AppConfigService } from '@/services/app-config.service';
import { AuthenticationService } from '@/services/authentication.service';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { RealProperty, Sharing, SharingRequest, SharingService } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

import { TooltipDirective } from '@/directives/tooltip/tooltip.directive';
import { ObjectUpdatedType } from '@/enums/ObjectUpdatedType.enum';
import { DateTimeFormatPipe } from '@/extensions/dateTimePipe';
import { Paging } from '@/models/Paging';
import { ActionService } from '@/services/action.service';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-share-request-table',
  templateUrl: './share-request-table.component.html',
  styleUrls: ['./share-request-table.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatMenuModule,
    MatPaginatorModule,
    NgFor,
    AsyncPipe,
    TooltipDirective,
    DateTimeFormatPipe
  ]
})
export class ShareRequestTableComponent implements OnInit, OnDestroy {
  @Input() prop: RealProperty;
  @Input() requests: SharingRequest[];

  dataSource: MatTableDataSource<Sharing>;
  displayedColumns = ['propertyName', 'userName', 'date', 'actions'];

  subs: Subscription[] = [];

  paging = new Paging();

  constructor(
    private sharingService: SharingService,
    private actionService: ActionService,
    private dialog: MatDialog,
    private alertService: AlertService,
    public authenticationService: AuthenticationService,
    private appConfigService: AppConfigService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  ngOnInit() {
    this.loadData();
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  loadData() {
    const displayedData = [];
    this.requests.forEach((i) => {
      const row = {
        request: i,
        propertyName: i.property.name,
        userName: UserHelper.userSummmaryDisplayName(i.user),
        date: i.date,
        message: i.message
      };
      displayedData.push(row);
    });
    this.dataSource = new MatTableDataSource(displayedData);
  }

  selectRequest(request: SharingRequest) {
    this.actionService.addShareFromRequest(request);
  }

  confirmDelete(request: SharingRequest) {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message:
            'Confirmez-vous la suppression de la demande pour "' +
            UserHelper.userSummmaryDisplayName(request.user) +
            '" ?'
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.doDelete(request);
        }
      });
    }
  }

  doDelete(request: SharingRequest) {
    this.subs.push(
      this.sharingService.deleteSharingRequest(request.uid).subscribe(() => {
        this.alertService.success('Suppression effectuée avec succès');
        this.appConfigService.triggerObjectUpdated(ObjectUpdatedType.SHARE);
      })
    );
  }
}
